import React from "react"

import type { Authentication } from "@/lib/authentication"
import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"

export const AuthenticationContext =
  React.createContext<Authentication.ContextData>({
    authUser: undefined,
    facebook: {
      authenticate: contextPlaceholderFunction,
      register: contextPlaceholderFunction,
    },
    google: {
      authenticate: contextPlaceholderFunction,
      register: contextPlaceholderFunction,
    },
    emailAndPassword: {
      forgotPassword: contextPlaceholderFunction,
      register: contextPlaceholderFunction,
      signIn: contextPlaceholderFunction,
    },
    fetchPatient: contextPlaceholderFunction,
    patient: undefined,
    processing: ``,
    providerId: undefined,
    signOut: contextPlaceholderFunction,
  })
